import { Box, Card, Separator, Shimmer } from '@betterment/samba-react';

export const CompactCardLoader = () => {
  return (
    <Card aria-busy="true" aria-label="Loading" css={{ p: 'space.300' }}>
      <Card.Header>
        <Shimmer css={{ height: '18px', maxWidth: '140px' }} />
      </Card.Header>
      <Separator css={{ my: 'space.300' }} />
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'space.100' }}>
        <Shimmer css={{ height: '14px', maxWidth: '200px' }} />
        <Shimmer css={{ height: '14px', maxWidth: '200px' }} />
      </Box>
    </Card>
  );
};
